import { Config } from "./Configs";
import { Container } from "./Containers";

export enum UserRole {
  admin = "ADMIN",
  superAdmin = "SUPER_ADMIN",
}

export interface User {
  _id: string;
  name: string;
  email: string;
  firebaseUID: string;
  role: UserRole;
  isActive: boolean;
  country?: string;
  city?: string;
  fiscalId?: number;
  phoneNumber?: string;
  address?: string;
  containersAmount?: number;
  slotsAmount?: number;
  sessions?: number[];
  configs?: Config[];
  containers?: Container[];
}
